import { Image, Box, CleanButton, Icon } from '@gassan-ui'
import { getKontentImage } from '@lib/kontent'
import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import shouldForwardProp from '@styled-system/should-forward-prop'

// @ts-ignore
const Scale = styled(Box).withConfig<{ isActive: boolean }>({
  shouldForwardProp
})`
  transition: transform 0.15s ease-out;
  transition-delay: ${p => (p.isActive ? '0.5s' : '.1s')};
  transform: ${p => (p.isActive ? `scale(0.75, 0.75)` : `scale(1, 1)`)};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &::before {
    content: '';
    padding-top: 100%;
    display: block;
  }
`

const Button = styled(CleanButton)<{ direction: 'prev' | 'next'; isActive: boolean }>`
  transition: ${p =>
    p.isActive
      ? 'opacity .2s ease .5s, border-color .2s ease'
      : 'opacity .2s ease, border-color .2s ease'};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  left: ${p => p.direction === 'prev' && '1.5rem'};
  right: ${p => p.direction === 'next' && '1.5rem'};
  opacity: ${p => (p.isActive ? 1 : 0)};
  color: ${p => p.theme.colors.shades[800]};
  width: ${rem(40)};
  height: ${rem(40)};
  border-radius: ${rem(20)};
  border: 2px solid rgba(0, 0, 0, 0);

  &:hover {
    border-color: ${p => p.isActive && p.theme.colors.shades[800]};
  }
  svg {
    position: absolute;
    top: -2px;
    left: -2px;
  }
`
// @ts-ignore
const Slide = styled(Box).withConfig<{ isActive }>({
  shouldForwardProp
})`
  opacity: ${p => (p.isActive ? 1 : 0)};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  transition: opacity 0.15s ease-in-out;
  object-fit: cover;
`

type Props = {
  images: string[]
  title?: string
  mouseEntered: boolean
}

const Images: FC<Props> = ({ images, title, mouseEntered }) => {
  const [index, setIndex] = useState(0)
  const next = e => {
    e.preventDefault()
    setIndex(index < images.length - 1 ? index + 1 : 0)
  }
  const prev = e => {
    e.preventDefault()
    setIndex(index > 0 ? index - 1 : images.length - 1)
  }

  useEffect(() => {
    if (!mouseEntered) {
      setIndex(0)
    }
  }, [mouseEntered])

  return (
    <>
      <Button direction="prev" isActive={mouseEntered} onClick={prev}>
        <Icon icon="chevron-left" />
      </Button>
      <Button direction="next" isActive={mouseEntered} onClick={next}>
        <Icon icon="chevron-right" />
      </Button>
      <Scale isActive={mouseEntered} suppressHydrationWarning>
        <Slide isActive={index === 0}>
          <Image
            placeholderSrc={getKontentImage(images[0], { width: 50 })}
            sources={[
              getKontentImage(images[0], { width: 350 }),
              getKontentImage(images[0], { width: 350 }),
              getKontentImage(images[0], { width: 450 })
            ]}
            alt={title}
            ratio={1}
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            loading="lazy"
          />
        </Slide>
        {mouseEntered &&
          images
            .slice(1)
            .map((src, key) => (
              <Slide
                as="img"
                key={key}
                src={getKontentImage(src, { width: 350 })}
                isActive={index === key + 1}
              />
            ))}
      </Scale>
    </>
  )
}

export default Images
